class SideBar extends HTMLElement {
  static activeControllers = new Set();
  static outsideClickHandler = (event) => {
    SideBar.activeControllers.forEach((controller) => {
      controller.closeOnClickOutside(event);
    });
  };

  static registerOpen(controller) {
    SideBar.activeControllers.add(controller);
    if (SideBar.activeControllers.size === 1) {
      document.addEventListener('click', SideBar.outsideClickHandler);
    }
  }

  static unregisterOpen(controller) {
    SideBar.activeControllers.delete(controller);
    if (SideBar.activeControllers.size === 0) {
      document.removeEventListener('click', SideBar.outsideClickHandler);
    }
  }

  constructor() {
    super();
    this.openSidebar = document.querySelectorAll('[sidebar-open]');
    this.sideBar = this;
    this.close = this.querySelectorAll('.tw-close');
    let self = this;
    this.currentSideBarOpen = false;

    this.openSidebar.forEach((element) => {
      element.addEventListener('click', () => { 
        this.open(element)
      });
    });

    this.close.forEach(close => {
      close.addEventListener('click', function() {
        const sideBar = self.currentSideBarOpen || self.sideBar;
        if(sideBar.classList.contains('sidebar-visible')) {
          sideBar.classList.remove("sidebar-visible");
          sideBar.classList.add("tw-hidden");
          self.scrollElements('unlock', self.querySelectorAll('.popup-content ul'));
          SideBar.unregisterOpen(self);
        }
      });
    });

    subscribe(PUB_SUB_EVENTS.sidebarOpen, (event) => {
      this.open(event)
    });

  }

  open(element) {
    if (element.sidebar && element.sidebar !== 'side-bar') return;
    let currentHandleSidebarOpen = element.source ? element.source : element.getAttribute('sidebar-open');
    let currentSideBar = `side-bar[handle="${currentHandleSidebarOpen}"]`;

    this.currentSideBarOpen = document.querySelector(currentSideBar);
    if (!this.currentSideBarOpen) return;

    this.currentSideBarOpen.classList.add("sidebar-visible");
    this.currentSideBarOpen.classList.remove("tw-hidden");

    this.scrollElements('lock', this.querySelectorAll('.popup-content ul'));
    SideBar.registerOpen(this);
  }

  scrollElements(action, selector) {
    if(action == 'lock') {
      selector.forEach(element => {
        scrollLock.disablePageScroll(element);
      });
    }

    if(action == 'unlock') {
      selector.forEach(element => {
        scrollLock.enablePageScroll(element);
      });
    }
  }

  closeOnClickOutside(event, action) {
    if (!event.target.closest('.sidebar-content')) {
        if (!Array.from(this.openSidebar).some(element => element.contains(event.target))) {
          const sideBar = this.currentSideBarOpen || this.sideBar;
          if(sideBar.classList.contains('sidebar-visible')) {
            sideBar.classList.remove("sidebar-visible");
            sideBar.classList.add("tw-hidden")
          };
            this.scrollElements('unlock', this.querySelectorAll('.popup-content ul'));
            SideBar.unregisterOpen(this);
        }
    }
  }
}

customElements.define('side-bar', SideBar);


/** Back in stock
* custom notify-popup
* https://help.backinstock.org/article/2303-javascript-api
**/
class notifyMePopup extends SideBar {
  constructor() {
      super();
      this.button          = this.querySelector('#notify_me');
      this.privacyField    = this.querySelector('.notify-me__privacy');
      this.privacy         = this.querySelector('#notify__privacy');
      this.newsletter      = this.querySelector('#notify__newsletter');
      this.email           = this.querySelector('#notify_email');
      this.select          = this.querySelector('#notify_variant');
      this.dialogContainer = this.querySelector('.dialog__container');
      this.dialog_notify   = this.querySelector(".dialog__notification");
      this.modalClose      = this.querySelector(".product-popup-modal__toggle");
      this.modal           = this.querySelector('.notifyme-popup.dialog.dialog__notify-me');
      this.modalOpen       = this.querySelector(".button-noProduct");
  }

  connectedCallback() {
    this.addEvents();
  }

  setHeight() {
    const header = this.querySelector('[data-header]');
    const body = this.querySelector('[data-body]');
    const footer = this.querySelector('[data-footer]');
  
    const getHeight = (el) => {
      if (!el) return 0;
      const style = window.getComputedStyle(el);
      const margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
      return (parseFloat(style.height) || el.offsetHeight || 0) + margin;
    };
  
    const headerH = getHeight(header);
    const bodyH = getHeight(body);
    const footerH = getHeight(footer);
  
  
    const height = headerH + bodyH + footerH;
  
    this.style.setProperty('--notify-me-height', `${height}px`);
  }

  open(element) {
    if (element.sidebar && element.sidebar !== 'notifyme-popup') return;
    let currentHandleSidebarOpen = element.source ? element.source : element.getAttribute('sidebar-open');
    let currentSideBar = `notifyme-popup[handle="${currentHandleSidebarOpen}"]`;
    this.currentSideBarOpen = document.querySelector(currentSideBar);
    if (!this.currentSideBarOpen) return

    this.currentSideBarOpen.classList.add("sidebar-visible");
    this.currentSideBarOpen.classList.remove("tw-hidden");

    this.scrollElements('lock', this.querySelectorAll('.popup-content ul'));
    SideBar.registerOpen(this);

    this.updateData(element.value);
    this.setHeight();
  }

  updateData(value) {
    
    let bisSelect = document.querySelector('#notify_variant'); 
    let updateCurrentVariant = this.querySelector('.current-variant');  
    if(value) {
      for(var i = 0; i < bisSelect.length; i++) {

        if(bisSelect[i].text == value) {
          bisSelect.selectedIndex = i;
          updateCurrentVariant.innerText = value;
          break;
        }
      }
    } else {
      bisSelect.selectedIndex = 0;
      updateCurrentVariant.innerText = bisSelect[0].getAttribute('value-size');
    }
  }

  addEvents() {

    subscribe(PUB_SUB_EVENTS.sidebarOpen, (event) => {
      this.open(event)
    });

    this.button.addEventListener('click', (event)  => {
      event.preventDefault();
      this.classList.remove('notification');
      if(this.privacy.checked) {
          const email       = this.email.value,
                productId   = this.select.getAttribute('data-product'),
                variantId   = this.select.value

          const email_regex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|'(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*')@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

          if(email.match(email_regex)){

            // Back in stock API
            BIS.create(email, variantId, productId)
              .then(this.notificationCallback())
              this.classList.add('notification');
            setTimeout(() => {
              this.email.value = "";
            }, 3000);

          } else {
            this.email.closest(".field").classList.add('field--error');
          }

      } else {
        this.privacyField.classList.add('field--error');
      }
    })
    this.email.addEventListener("click", ()=>{
      if(this.email.closest(".field").classList.contains("field--error")){
        this.email.closest(".field").classList.remove("field--error")
      }
    });
    this.privacyField.addEventListener("click", ()=>{
      if(this.privacyField.classList.contains("field--error")){
        this.privacyField.classList.remove("field--error")
      }
    });
  }

  notificationCallback(){
    this.dialog_notify.classList.remove("tw-hidden");
  }
}
customElements.define('notifyme-popup', notifyMePopup);
